// Dollars with the sign in front of the symbol: "-$173,176.45", never
// "$-173,176.45". Digits are exactly what toLocaleString() printed before.
export function formatUsd(amount) {
  const n = Number(amount) || 0;
  return `${n < 0 ? "-" : ""}$${Math.abs(n).toLocaleString()}`;
}
